import { Dialog, TextField } from "@mui/material";
import { useState } from "react";

import DialogContentSelectGeneric from "./DialogsContents/DialogContentGeneric";
import { defValueCaixaBancoConta, TCaixaBancoContas } from "../../types/api/financeiro/caixa-banco-contas";

export default function SelectContaCaixaBanco({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    onChange,
    disabled = false,
    label = "Conta bancária"
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => setOpenModal(false)

    const inputLabel = value ? `${value.codigo} - ${value.nome}` : ""

    return (
        <>
            <TextField
                {...{ required, error, disabled }}
                label={label}
                variant="outlined"
                fullWidth
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose }}
                        title="Selecionar conta bancária"
                        queryPath="/financeiro/caixa-bancos/pesquisar-contas"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.codigo} - ${item.nome}`}
                        defaultValue={value || defValueCaixaBancoConta}
                        onChange={(value) => {
                            onChange(value as TCaixaBancoContas)
                            handleClose()
                        }}
                    />
                </Dialog>

            }
        </>
    )
}

interface SelectSimpleApiQueryProps {
    value: TCaixaBancoContas | null | undefined
    onChange: (arg: TCaixaBancoContas | null) => void
    required?: boolean
    error?: boolean
    errorMessage?: string | undefined
    disabled?: boolean
    label?: string
}